export default "__VITE_ASSET__BUzY8Rom__"